import { render, staticRenderFns } from "./RestartCampaign.vue?vue&type=template&id=c67da2da&scoped=true&"
import script from "./RestartCampaign.vue?vue&type=script&lang=js&"
export * from "./RestartCampaign.vue?vue&type=script&lang=js&"
import style0 from "./RestartCampaign.vue?vue&type=style&index=0&id=c67da2da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c67da2da",
  null
  
)

export default component.exports